export default {
    // $ 公共
    general_button_cancel: 'Annulla',
    general_button_sure: 'Conferma',
    general_button_close: 'Chiudi',
    general_text_update_faild: 'Aggiornamento non riuscito',
    general_button_done: 'Fatto',
    general_text_no_data: 'Nessun dato trovato',
    general_text_ordered: 'Ordinato',
    general_text_next_turn_time: 'Turno',
    general_text_get_limit_rule_failed: 'Impossibile ottenere le regole del turno',
    general_text_customer_not_exist: 'L\'utente {{n}} non esiste',
    general_text_can_not_get_rules_of_dish: 'Impossibile ottenere i dati del piatto',

    // $ 历史订单
    order_history_page_text_no_make: 'Non fatto',
    order_history_page_text_make_complete: 'In consegna',
    order_history_page_text_service_complete: 'Servito',
    order_history_page_text_unable_make: 'Annulato',
    order_history_page_text_pause_make: 'Sospeso',
    order_history_page_text_waiter: 'Cameriere',
    order_history_page_text_customer: 'Cliente',
    order_history_page_text_extra: 'Tassa aggiuntiva',
    order_history_page_text_order_devices: 'Altri dispositivi',
    history_order_you: 'Cliente',
    history_order_round: 'Il turno {{round}}',
    history_order_total: 'in totale {{number}} piatti',

    // $ 呼叫服务
    service_page_text_call_service_select: 'Chiama il servizio (opzionale)',
    service_page_text_insert_texts: 'Inserisci il contenuto (opzionale)',
    service_page_text_call_waiter: 'Chiama il cameriere',
    service_page_text_call_service: 'Chiama il servizio',
    service_page_text_table_name: 'Nome del tavolo',
    service_page_text_Please_select_a_service: 'Seleziona un servizio',
    service_page_text_Your_requirement: 'Il tuo requisito (facoltativo)',
    service_page_text_call_service_success_message: 'chiamata con successo',
    service_page_input_placeholder_message: 'Inserisci la tua richiesta...',

    // $ 购物车
    order_cart_page_text_total: 'Totale',
    order_cart_page_text_complete_order: 'Hai completato l\'ordine per il turno corrente',
    order_cart_page_text_round_max_order_count: 'Limite di ordini del turno: {{n}}',
    order_cart_page_text_round_max_number_exceed: 'Superato il limite di ordini',
    order_cart_page_text_similar_dish_number_exceed: 'Superato il limite della categoria',
    order_cart_page_text_same_dish_number_exceed: 'Superato limite ordine del piatto',
    order_cart_page_text_max_rounds_exceed: 'Superato il limite del turno',
    order_cart_page_text_dish_not_exists: 'Il piatto non esiste',
    order_cart_page_text_commit_cart_fail: 'Invio al carrello non riuscito',
    order_cart_page_text_commit_success: 'Invio riuscito',
    order_cart_page_text_cart_not_data: 'Nessun dato',
    order_cart_page_text_select_preferences: 'Fai clic sul nome del piatto per scegliere il condimento',
    order_cart_page_text_disable_edit_second: 'Dopo {{s}} secondi si entra nel turno successivo',
    order_cart_page_text_print_credential_fail: 'Stampa non riuscita',
    order_cart_page_text_dish_remarks: 'Note dei piatti',
    order_cart_page_text_self: 'Self',
    order_cart_page_text_cannot_at_the_same_time: 'Si prega di non inviare il carrello o modificare gli articoli del carrello contemporaneamente',
    order_cart_page_text_is_submitting: 'Invio ordine in corso',
    order_cart_page_text_round_rules: 'Puoi inviarlo solo una volta per turno. Hai ancora una quantità inutilizzata. Sei sicuro di volerlo inviare?',
    order_cart_page_text_clear: 'Svuota',
    order_cart_page_text_delete: 'Cancella',
    order_cart_page_text_exe_dishes_commit: 'Ci sono piatti in eccesso, se continuare a presentare',
    order_cart_page_text_confirm_modification: 'Conferma',
    order_cart_page_text_sync_round_info_success: 'Il turno è stato aggiornato con successo',
    order_cart_page_text_dish_is_sold_out: 'Questo piatto è esaurito',
    order_cart_page_text_sold_out: 'Esaurito',
    order_cart_Page_text_verify_sold_out_dishes_message: 'La quantità disponibile per il piatto "{{menuName}}" è {{excessedNum}}.',

    // $ 点餐
    menu_page_text_please_select_your_id: 'Si prega di inserire l\'ID',
    menu_page_text_check_tip_id: 'Hai dimenticato ID? Controlla la cronologia degli ordini per recuperare',
    menu_page_text_dishes_copy: '{{n}} è stato ordinato {{1}} volta/e in questo turno',
    menu_page_text_more_than_half_ordered: '{{n}} persone hanno ordinato {{dish}}',
    menu_page_text_not_show: 'Non mostrare più questo messaggio',
    menu_page_text_under_review_wait: 'In revisione, attendere prego',
    menu_page_text_order_success_created_jump: 'L\'ordine è stato creato con successo, vai alla pagina del menù',
    menu_page_text_order_does_not_exist: 'L\'ordine non esiste o il tavolo è stato reimpostato, riaprilo',
    menu_page_text_review_rejected: 'Revisione rifiutata',
    menu_page_text_under_review: 'In revisione',
    menu_page_text_locked_state: 'L\'ordine è stato bloccato, puoi sfogliare il menù liberamente',
    menu_page_text_reset_send: 'Richiesta di revisione',
    menu_page_text_reset_send_success: 'Richiesta riuscita',
    menu_page_text_approved: 'Approvato',
    menu_page_text_order_unlocked: 'L\'ordine è stato sbloccato',
    menu_page_text_table_invalid: 'Tavolo non valido',
    menu_page_text_customer_id_occupy: 'L\'ID è già in uso',
    menu_page_text_dish_time_disable: 'Alcuni menù sono stati disabilitati a causa della chiusura della cucina',
    menu_page_text_notice_time: 'La cucina chiuderà tra {{time}} minuti. Si prega di ordinare i piatti prima della chiusura della cucina',
    menu_page_text_allergen_filter_label_message: 'Seleziona i piatti da filtrare',
    menu_page_text_allergen: 'Allergeni',
    menu_page_text_ingredents: 'Altri tag piatto',
    menu_page_text_ingredent_filter_label_message: 'Seleziona i piatti da filtrare',
    menu_page_text_filter: 'Filtro',
    menu_page_text_dish_exceeded: 'Il piatto che stai aggiungendo al carrello ha superato il limite della quantità di questo articolo. Se continui, ti potrebbe essere addebitato un costo aggiuntivo',

    // $ 扫码入口页
    home_page_text_please_select_menu: 'Seleziona il menù',
    home_page_text_number_of_adults: 'Numero di adulti',
    home_page_text_number_of_child: 'Numero di bambini',
    home_page_text_adult_price: 'Prezzo adulti',
    home_page_text_child_price: 'Prezzo bambini',
    home_page_text_normal: 'Standard',
    home_page_text_special: 'Speciale',
    home_page_text_table_pause_use: 'Il tavolo non è disponibile',
    home_page_text_order_now: 'Ordina ora',
    home_page_text_get_menu_fail: 'Non è stato possibile caricare il menù, riprova',
    home_page_text_announcement: 'Notifica',

    // $ 公告页
    notice_page_text_no_picture: 'Nessuna immagine',

    // $ 过敏源种类
    text_gluten: "Glutine",
    text_crustaceans: "Crostacei",
    text_eggs: "Uova",
    text_fish: "Pesce",
    text_peanuts: "Arachidi",
    text_soya: "Soia",
    text_milk: "Latte",
    text_tree_nuts: "Noci",
    text_celery: "Sedano",
    text_mustard: "Mostarda",
    text_sesame: "Sesamo",
    text_sulphites: "Solfiti",
    text_lupin: "Lupino",
    text_molluscs: "Molluschi",
    text_mild_spicy: "Poco piccante",
    text_medium_spicy: "Medio piccante",
    text_very_spicy: "Piccante",
    text_frozen_origin: "Congelato",
    text_blast_freezing: "Surgelato",
    text_vegetarian: "Vegetariano",
    text_vegan: "Vegano",
    text_gluten_free: "Gluten free",
    text_raw: "Crudo",
    text_cooked: "Cotto",
    text_additives: "Additivi",
    text_colourants: "Coloranti",

    // 新手引导
    novice_guide_text_select_menu: 'Seleziona il menù',
    novice_guide_text_select_normal_menu: 'Seleziona il menù standard',
    novice_guide_text_select_special_menu: 'Seleziona un menù speciale',
    novice_guide_text_select_number_of: 'Scegli il numero di ospiti',
    novice_guide_text_order: 'Ordina',
    novice_guide_text_announcement: 'Notifica',
    novice_guide_text_cart: 'Carrello',
    novice_guide_text_history: 'Cronologia ordini',
    novice_guide_text_call: 'Chiama il servizio',
    novice_guide_text_switch_dish_mode: 'Cambia la modalità di visualizzazione del menù',
    novice_guide_text_first_menu: 'Seleziona il menù principale',
    novice_guide_text_switch_user: 'Mostra l\'utente corrente',
    novice_guide_text_round_dish: 'Controlla il numero del turno',
    novice_guide_text_click_dish_card_add: 'Fai clic su quest\'area per ordinare i piatti',
    novice_guide_text_click_dish_card_reduce: 'Fai clic su quest\'area per rimuovere i piatti',
    novice_guide_text_enlarge_dish_card: 'Fai clic su quest\'area per visualizzare i dettagli del piatto',
    novice_guide_text_click_cancel: 'Fai clic per annullare la guida',
    novice_guide_text_reduce_order: 'Riduci l\'ordine',
    novice_guide_text_increase_order: 'Aumenta l\'ordine',
    novice_guide_text_table: 'Tavolo',
    novice_guide_text_enter_number: 'Immetti il numero di ospiti',
    novice_guide_text_swipe_to_switch: 'Scorri per cambiare',
    novice_guide_text_home: 'Pagina iniziale',

    // 自助开台
    auto_open_page_text_featured_dishes: 'Piatti speciali',
    auto_open_page_text_order_now: 'Ordina ora',
    auto_open_page_text_opening_hours: 'Orari disponibili per l\'ordinazione',
    auto_open_page_text_media: 'Social media',
    auto_open_page_text_website: 'Sito ufficiale',
    auto_open_page_text_reservation: 'Prenotazione',
    auto_open_page_text_takeaway: 'Takeaway',
    auto_open_page_text_without_menu: 'Nessun menù è selezionabile al momento',
    auto_open_page_adults: 'Adulti',
    auto_open_page_other: 'Altri',
    auto_open_page_children: 'Bambini',
    auto_open_page_text_menu: 'Menù',
    text_persons: 'Ospiti',
    auto_open_page_open_table: 'Apertura tavolo',
    auto_open_page_select: 'Seleziona',
    auto_open_page_see_more: 'Visualizza di più',
    auto_open_page_text_disabled_message: 'L\'apertura dei tavoli self-service è disabilitata, si prega di contattare il staff.',

    // 临时密码功能
    auto_open_page_text_set_temporary_password: 'Crea un PIN temporaneo',
    auto_open_page_text_input_temporary_password: 'Si prega di inserire il PIN',
    auto_open_page_text_reset_temporary_password: 'Reimposta PIN',
    auto_open_page_text_cancel_temporary_password: 'Annulla PIN',
    auto_open_page_text_forgot_password: 'PIN dimenticato',
    auto_open_page_text_input_password: 'Inserisci un numero di 4 cifre',
    auto_open_page_text_go_back: 'Indietro',
    auto_open_page_text_confirm_changes: 'Conferma',
    auto_open_page_incorrect_pin: 'PIN errato',
    auto_open_page_modification_failed: 'Modifica non riuscita',
    auto_open_page_modification_succeed: 'Modifica riuscita',
    auto_open_page_button_confirm: 'Conferma',
    auto_open_page_employee_account: 'User',
    auto_open_page_employee_password: 'Password',
    auto_open_page_pin: 'PIN',

    // 复合型营业时间
    general_text_all_day_business: 'Aperto 24 ore',
    general_text_business_hours: "Orario di lavoro fisso",
    general_text_compound_business_hours: "Orario di lavoro settimanale",

    // 餐厅区域
    general_text_You_are_not_in_the_restaurant_area_unable_to_order: "Non sei nell'area ristorante, impossibile ordinare",
    general_text_Getting_your_location_failed: 'Impossibile ottenere correttamente la tua posizione',

    general_text_poor_network: 'Impossibile connettersi al server o alla rete instabile, riprovare più tardi',

    // 点餐 - 套餐相关
    menu_page_text_setMenu: 'Menù',
    menu_page_text_choose_the_products: 'Seleziona il prodotto',
    menu_page_text_add_to_cart: 'Aggiungi al carrello',
    menu_page_text_set_menu_required: 'necessario',
}